/**
 * AI Chat configuration.
 *
 * SESSION_TIMEOUT_HOURS — hours of inactivity after which a chat session is
 * considered expired and reset to a new conversation.
 * Default: 12h. Override via VITE_AI_CHAT_SESSION_TIMEOUT_HOURS env var.
 */
export const AI_CHAT_CONFIG = {
  /**
   * Number of hours of inactivity before a chat session is treated as new.
   * Configurable via VITE_AI_CHAT_SESSION_TIMEOUT_HOURS in .env.
   */
  SESSION_TIMEOUT_HOURS: Number(
    import.meta.env.VITE_AI_CHAT_SESSION_TIMEOUT_HOURS ?? 12
  ),
} as const;
